import { type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=A%20wide%20editorial%20flat%20lay%20of%20colorful%20sneakers%20folded%20hoodies%20caps%20and%20accessories%20arranged%20in%20an%20organized%20grid%20on%20a%20soft%20sage%20green%20and%20warm%20sand%20two-tone%20backdrop%20soft%20natural%20daylight%20premium%20e-commerce%20hero%20photography%20airy%20composition%20fresh%20modern%20aesthetic&width=1600&height=900&seq=hero-usfans&orientation=landscape&nocache=true';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToBrowse = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    document.getElementById('browse')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="USFans Spreadsheet fashion collection"
          title="USFans Spreadsheet resources"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 px-4 py-20 md:px-6 md:py-28">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-white backdrop-blur">
            {t('hero.eyebrow')}
          </span>

          <h1 className="mt-6 font-display text-3xl font-bold leading-tight text-white md:text-5xl">
            {t('hero.title')}
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/90 md:text-lg">
            {t('hero.subtitle')}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-emerald-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-emerald-700"
            >
              {t('hero.ctaPrimary')}
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-white px-6 py-3 text-sm font-semibold text-stone-900 transition-colors hover:bg-stone-100"
            >
              {t('hero.ctaSecondary')}
            </a>
          </div>

          <form onSubmit={scrollToBrowse} className="mt-8 w-full max-w-md">
            <div className="relative">
              <span className="pointer-events-none absolute left-4 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center">
                <i className="ri-search-line text-base text-stone-400"></i>
              </span>
              <input
                type="text"
                placeholder={t('hero.searchPlaceholder')}
                className="w-full rounded-full border border-white/30 bg-white/95 py-3 pl-11 pr-4 text-sm text-stone-800 placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
          </form>

          <p className="mt-6 text-xs font-medium uppercase tracking-widest text-white/80">
            {t('hero.trust')}
          </p>
        </div>
      </div>
    </section>
  );
}